import $ from 'jquery';

export function getStripeCheck(){

  return $.ajax({
    method: "GET",
    dataType: 'json',
    traditional: true,
    data: {},
    xhrFields: {
      withCredentials: true
   },
    url: `${process.env.REACT_APP_API}/stripeconnectoauth/onboardcheck`,
    
    headers: {
        "Authorization": "Bearer " + localStorage.getItem('accessToken'),
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    },
  }).then(res => res.data).catch(res => res)
}